import { render, staticRenderFns } from "./pagination-center.vue?vue&type=template&id=6857be58"
import script from "./pagination-center.vue?vue&type=script&lang=ts"
export * from "./pagination-center.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6857be58')) {
      api.createRecord('6857be58', component.options)
    } else {
      api.reload('6857be58', component.options)
    }
    module.hot.accept("./pagination-center.vue?vue&type=template&id=6857be58", function () {
      api.rerender('6857be58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/pagination-center.vue"
export default component.exports